/* global fbq */
import React, { useEffect } from 'react';
import Info from "../../components/svgicons/infoIcon";
import { Modal, ModalHeader } from "reactstrap";
import { useNavigate } from "react-router-dom";
import OrderPlacedIcon from "../../images/home/green-check-icon.svg";
import "./styles.scss";
import axios from "axios";

function ThankYouModal({
  openModal,
  setOpenModal,
  orderAmount,
  orderDetails,
  openErrorModal,
  setOpenErrorModal,
  errorModalError,
}) {
  const navigate = useNavigate();
  const loadFacebookPixel = ({ orderAmount, orderId }) => {
    if (
      process.env.REACT_APP_NODE_ENV === "production" &&
      typeof window !== 'undefined'
      &&
      !window.location.href.includes('localhost')
      && localStorage.getItem("landingSource")?.includes("qc")
    ) {
      const postData = {
        appType: "Buyer-app",
        eventName: "Purchase",
        orderId: orderId
      };

      axios.post(`${process.env.REACT_APP_KIKO_API_BASE_URL_V2?.replace("ondc-seller", "ondc-buyer")}/add-event`, postData)
        .then(response => {
          console.log('Response:', response.data);
        })
        .catch(error => {
          console.error('Error:', error.response ? error.response.data : error.message);
        });
      //Avoid injecting multiple times
      if (window.fbq) {
        fbq('track', 'Purchase', { value: orderAmount, currency: 'INR' });
        return;
      }


      fbq('init', '326242339368504');
      fbq('track', 'PageView');
      fbq('track', 'Purchase', { value: orderAmount?.toFixed(2), currency: 'INR' });
      fbq('track', 'Complete Registration');

      // Optional: Add <noscript> image if desired
      const noscriptImg = document.createElement('img');
      noscriptImg.src =
        'https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1';
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      document.body.appendChild(noscriptImg);
    }
  };

  useEffect(() => {
    if (openModal) {
      loadFacebookPixel({ orderAmount: orderDetails?.orderAmount || 0, orderId: orderDetails?.orderId || "" });
    }
  }, [openModal]);
  return (
    <>
      <Modal
        isOpen={openModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal-kl thankyou-modal-kl"
      >

        <div className="custom-modal-body-kl text-center">
          <div className="thankyou-modal-green-check-icon-kl">
            <img src={OrderPlacedIcon} alt="orderPlaced" />
          </div>
          <div className="thankyou-modal-order-title-kl">Thank You for Shopping with Us!</div>
          <hr className="thankyou-modal-hr-kl" />
          <div className="thankyou-modal-order-sub-title-kl mb-4">
            <div>{`Your order for ${orderDetails?.itemsCount ?? ""
              } Item(s) worth ₹${orderAmount?.toFixed(2) ?? ""
              } has been confirmed.`}</div>
          </div>
          <div className="thankyou-modal-order-sub-title-kl d-flex align-content-center justify-content-center gap-2 mb-4">
            {`Order ID: `}
            <a
              href="/buyer-order-details"
              onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
              onMouseOut={(e) => (e.target.style.textDecoration = "none")}
              onClick={() => {
                setOpenModal(false);
                localStorage.removeItem("cart");
                navigate(localStorage.getItem("slug"));
                navigate("/")
                navigate("/buyer-order-details", {
                  state: { orderId: orderDetails?._id },
                });
              }}
            >
              {`${orderDetails?.orderId}`}
            </a>
          </div>
          <div className="update-delivery-info-text-kl">{"Updates on delivery will be shared shortly."}</div>
          <button
            className="continue-shopping-btn-kl view-order-details-btn-kl mb-3"
            onClick={() => {
              setOpenModal(false);
              localStorage.removeItem("cart");
              navigate(localStorage.getItem("slug"));
              navigate("/")
              navigate("/buyer-order-details", {
                state: { orderId: orderDetails?._id },
              });
            }}
          >
            View Order Details
          </button>
          <button
            className="continue-shopping-btn-kl mb-3"
            onClick={() => {
              setOpenModal(true);
              localStorage.removeItem("cart");
              navigate("/")
              navigate("/seller?pid=" + orderDetails?.providerId);
            }}
          >
            Continue Shopping
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={openErrorModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="thankyouModal oops-modal"
      >
        <ModalHeader>
          <div>
            <h1>
              <Info className="icon" />
              Oops!!
              <br /> <br />
              Something Went Wrong !
              <br /> <br />
              Your money will be refunded in 2-3 days.
            </h1>
            <br /> <br />
            {/* <p className="technical-popup-error">
              {errorModalError ? errorModalError : ""}
            </p> */}
            <button
              className="trackOrder"
              onClick={() => {
                setOpenErrorModal(false);
                localStorage.removeItem("cart");
                navigate(localStorage.getItem("slug"));
              }}
            >
              Explore More
            </button>
          </div>
        </ModalHeader>
        <div style={{ height: "0px" }}></div>
      </Modal>
    </>
  );
}

export default ThankYouModal;